'use client';

import CustomPortableText from '@/components/CustomPortableText/CustomPortableText';
import CopyShareLink from '@/components/ui/CopyShareLink/CopyShareLink';
import ImageFigure from '@/components/ui/ImageFigure/ImageFigure';
import TimeAgo from '@/components/ui/TimeAgo/TimeAgo';
import { useDictionary } from '@/context/DictionaryContext';
import { EditorialContent, isWrittenContent } from '@/types/content';
import { generateLocalizedURL } from '@/utils/url';

import styles from './LiveblogUpdate.module.scss';

interface LiveblogUpdateProps {
  update: EditorialContent;
}

const LiveblogUpdate = ({ update }: LiveblogUpdateProps) => {
  if (!isWrittenContent(update)) {
    return null;
  }

  const { t } = useDictionary();

  const ISBreaking = () => {
    if (update.isBreaking) {
      return <strong className={styles.breaking}>{t('label.breaking')} </strong>;
    }
    return null;
  }

  const Tag = () => {
    if (update.tags && update.tags.length > 0) {
      return (
        <strong
          style={{
            display: 'block',
            color: update.tags[0].color,
          }}
        >
          {update.tags[0].title}
        </strong>
      );
    }
    return null;
  }

  return (
    <article className={styles.update}>
      <header className={styles.updateHeader}>
        <div className={styles.updateHeaderContent}>
          <strong className={styles.updateDate}>
            <TimeAgo dateTime={update.publishedAt} language={update.language} />
          </strong>
          <h3 className={styles.updateHeadline}>
            {ISBreaking()}
            {Tag()}
            {update.headline}
          </h3>
        </div>
        <div className={styles.updateHeaderActions}>
          <CopyShareLink
            shareLink={
              generateLocalizedURL(
                update.slug,
                update.language
              )
            }
          />
        </div>
      </header>
      <main className={styles.updateBody}>
        {update.image && <ImageFigure image={update.image} alt={update.headline} className={styles.imageFigure} />}
        {update.lead && <p className="paragraph">{update.lead}</p>}
        {update.body && <CustomPortableText value={update.body as any} />}
      </main>
    </article>
  )
};

export default LiveblogUpdate;